(function () {
  function mountBannerSevenContent() {
    var slide = document.querySelector('#shopify-section-home #anHero.hero .hero-slide:nth-child(7)');
    if (!slide) return;

    var fullLink = slide.querySelector('.hero-link');
    if (fullLink) {
      fullLink.href = '/collections/party-wear';
      fullLink.setAttribute('aria-label', 'Shop party fragrances');
    }

    if (slide.querySelector('.an-hero-copy-layer--night')) return;

    var scrim = document.createElement('div');
    scrim.className = 'an-hero-copy-scrim an-hero-copy-scrim--night';
    scrim.setAttribute('aria-hidden', 'true');

    var layer = document.createElement('div');
    layer.className = 'an-hero-copy-layer an-hero-copy-layer--night';
    layer.innerHTML = [
      '<div class="an-hero-copy an-hero-copy--night">',
      '<h2 aria-label="Let The Night Remember You">',
      '<span class="an-hero-night-line">Let The Night</span>',
      '<span class="an-hero-night-line an-hero-night-accent">Remember You.</span>',
      '</h2>',
      '<p>Magnetic fragrances made for every entrance, every glance and every unforgettable hour.</p>',
      '<a class="an-hero-cta an-hero-cta--night" href="/collections/party-wear">Shop Party Scents</a>',
      '</div>'
    ].join('');

    slide.appendChild(scrim);
    slide.appendChild(layer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountBannerSevenContent);
  } else {
    mountBannerSevenContent();
  }

  window.addEventListener('pageshow', mountBannerSevenContent);
  document.addEventListener('shopify:section:load', mountBannerSevenContent);
})();
